/**
 * أزرار التقرير: Excel للتحليل، والطباعة لـ PDF الذى يُرسل أو يُحفظ. الطباعة من المتصفح
 * نفسه لا من مكتبة PDF: المتصفح يرسم العربية والاتجاه من اليمين صحيحين، ومكتبة PDF
 * تحتاج خطًا مضمَّنًا ومعالجة للحروف المتصلة — مصدر أخطاء لا داعى له.
 */
export default function ReportActions({ onExport }: { onExport: () => void }) {
  return (
    <div className="panel-actions no-print">
      <button type="button" className="ghost" onClick={onExport}>
        تصدير Excel
      </button>
      <button type="button" className="ghost" onClick={() => window.print()}>
        طباعة / PDF
      </button>
    </div>
  );
}
